module.exports = __webpack_public_path__ + "img/lightning.8151ef64.svg";